import { Button } from "../../ui";
import {
  formatSubscriptionRub,
  resolveSubscriptionPresentation,
} from "../../../utils/clubSubscriptionUi";
import { billingBadgeClass, formatDateRu } from "../../Platform/OwnerCabinet/OwnerShell";
import os from "../../Platform/OwnerCabinet/ownerCabinet.module.css";
import ss from "./subscription.module.css";

function resolveOwnerPayLabel(billing, needsPay) {
  if (needsPay) return "Оплатить";
  if (billing?.is_trial) return "Выбрать тариф";
  if (billing?.is_expiring_soon) return "Продлить";
  return "Сменить тариф";
}

export default function OwnerClubSubscriptionCard({
  club,
  onOpenAdmin,
  onPay,
  variant = "full",
}) {
  const billing = club.billing;
  const pres = resolveSubscriptionPresentation(billing, club.name);
  const needsPay =
    billing?.is_demo_expired || (!billing?.is_paid && !billing?.is_trial);
  const price = club.plan?.monthly_price_rub ?? billing?.monthly_price_rub;
  const payLabel = resolveOwnerPayLabel(billing, needsPay);
  const planLabel = billing?.plan_label || club.plan?.name || "—";
  const untilLabel = billing?.is_trial ? "Демо" : "До";
  const untilValue = billing?.paid_until
    ? formatDateRu(billing.paid_until)
    : billing?.days_left != null
      ? `${billing.days_left} дн.`
      : "—";

  const handlePay = () => {
    if (onPay) onPay(club);
  };

  if (variant === "list") {
    return (
      <article className={ss.ownerClubListCard}>
        <div className={ss.ownerClubListHead}>
          <div className={ss.ownerClubListTitleBlock}>
            <h2 className={ss.ownerClubListTitle}>{club.name}</h2>
            <p className={ss.ownerClubListHost}>{club.host}</p>
          </div>
          <span className={`${os.badge} ${billingBadgeClass(billing)}`}>
            {needsPay ? "Не оплачен" : pres.badge}
          </span>
        </div>

        <div className={ss.ownerClubListMeta}>
          <span>{planLabel}</span>
          <span className={ss.ownerClubListDot} aria-hidden>
            ·
          </span>
          <span>
            {untilLabel} {untilValue}
          </span>
          {price ? (
            <>
              <span className={ss.ownerClubListDot} aria-hidden>
                ·
              </span>
              <span>от {formatSubscriptionRub(price)} ₽/мес</span>
            </>
          ) : null}
        </div>

        {pres.progress != null ? (
          <div className={ss.ownerClubListBar}>
            <div
              className={ss.ownerClubListBarFill}
              style={{ width: `${pres.progress}%` }}
            />
          </div>
        ) : null}

        <div className={ss.ownerClubListActions}>
          {onOpenAdmin ? (
            <Button
              type="button"
              variant="secondary"
              block
              onClick={() => onOpenAdmin(club)}
            >
              В кабинет
            </Button>
          ) : null}
          <Button type="button" variant="primary" block onClick={handlePay}>
            {payLabel}
          </Button>
        </div>
      </article>
    );
  }

  return (
    <div className={ss.ownerClubCard}>
      <div className={os.cardHead}>
        <div>
          <h2 className={os.cardTitle}>{club.name}</h2>
          <p className={os.cardMeta}>{club.host}</p>
        </div>
        <span className={`${os.badge} ${billingBadgeClass(billing)}`}>
          {needsPay ? "Не оплачен" : pres.badge}
        </span>
      </div>

      <div
        className={`${ss.hero} ${
          needsPay
            ? ss.heroUnpaid
            : pres.variant === "trial"
              ? ss.heroTrial
              : ss.heroActive
        }`}
      >
        <span
          className={`${ss.heroBadge} ${
            needsPay
              ? ss.heroBadgeWarn
              : pres.variant === "trial"
                ? ""
                : ss.heroBadgeOk
          }`}
        >
          {pres.badge}
        </span>
        <h3 className={ss.heroTitle} style={{ fontSize: 17, marginTop: 8 }}>
          {pres.title}
        </h3>
        <p className={ss.heroMeta}>{pres.meta}</p>
        {pres.progress != null ? (
          <div className={ss.heroBar}>
            <div
              className={ss.heroBarFill}
              style={{ width: `${pres.progress}%` }}
            />
          </div>
        ) : null}
      </div>

      <div className={ss.ownerClubStats}>
        <div className={ss.ownerClubStat}>
          <div className={ss.ownerClubStatLabel}>Тариф</div>
          <div className={ss.ownerClubStatValue}>{planLabel}</div>
        </div>
        <div className={ss.ownerClubStat}>
          <div className={ss.ownerClubStatLabel}>
            {billing?.is_trial ? "Демо до" : "Оплачено до"}
          </div>
          <div className={ss.ownerClubStatValue}>{untilValue}</div>
        </div>
      </div>

      {price ? (
        <p className={ss.pickerHint}>
          от {formatSubscriptionRub(price)} ₽ / мес
        </p>
      ) : null}

      <div className={ss.ownerClubActions}>
        {onOpenAdmin ? (
          <Button
            type="button"
            variant="secondary"
            block
            onClick={() => onOpenAdmin(club)}
          >
            В кабинет
          </Button>
        ) : null}
        <Button type="button" variant="primary" block onClick={handlePay}>
          {payLabel}
        </Button>
      </div>
    </div>
  );
}
